import React, { useEffect, useState, memo } from 'react';
import axios from 'axios';
import FlipNumbers from 'react-flip-numbers';
import { Card } from 'react-bootstrap';
import { useAppContext } from '../../providers/AppProvider.js';
import { FallingLines } from 'react-loader-spinner';
import { isLiveTimeRange } from '../charts/utils/chartUtils';
import { INFLUX_API } from '../../config/api';

const SparkTesterPieces = ({ bucket, machineName, startTime, endTime }) => {
  const [sparkPieces, setSparkPieces] = useState(0);
  const {
    config: { theme },
    getThemeColor
  } = useAppContext();
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${INFLUX_API}/api/influx/${machineName}/spark-pieces?start=${startTime}&end=${endTime}&bucket=${bucket}`
      );

      if (response.data.length > 0) {
        setSparkPieces(response.data[0]._value);
      }
    } catch (error) {
      console.error('Error fetching SparkTesterPieces data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    const intervalId = isLiveTimeRange(endTime) ? setInterval(fetchData, 60000) : null; // Refresh every 60 seconds
    return () => clearInterval(intervalId);
  }, [startTime, endTime]);

  if (loading) {
    return (
      <Card className="h-100">
        <Card.Body style={{ height: '316px', width: '100%' }}>
          <div style={styles.spinnerContainer}>
            <FallingLines
              color={theme === 'dark' ? 'white' : '#3874ff'}
              width="100"
              visible={true}
              ariaLabel="loading-spark-pieces"
            />
          </div>
        </Card.Body>
      </Card>
    );
  }

  return (
    <Card className="h-100">
      <Card.Body className="d-flex flex-column align-items-center justify-content-center">
        <h5 style={{ color: getThemeColor('dark'), fontWeight: 'bold' }}>
          Spark Tester Pieces
        </h5>
        <FlipNumbers
          height={50}
          width={50}
          color={'#3874ff'}
          background="none"
          play
          perspective={500}
          numbers={`${sparkPieces}`}
          duration={5}
        />
      </Card.Body>
    </Card>
  );
};

const styles = {
  spinnerContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%'
  }
};

export default memo(SparkTesterPieces);
